export default __webpack_public_path__ + "static/media/ewf.1f2da04d.svg";